import { styled } from '@mui/material/styles';
import FilterWrapper from '../FilterWrapper/index.js';

var PREFIX = "FilterCheckbox";
var classes = {
    formControlLabel: "".concat(PREFIX, "-formControlLabel"),
    formGroup: "".concat(PREFIX, "-formGroup"),
    label: "".concat(PREFIX, "-label"),
    input: "".concat(PREFIX, "-input"),
    multiSelect: "".concat(PREFIX, "-multiSelect")
};
var StyledFilterCheckbox = styled(FilterWrapper)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.formControlLabel)] = {
            width: "100%",
            "& .MuiTypography-body1": {
                // 42px is the size of the checkbox
                width: "calc(100% - 42px)"
            }
        },
        _b["& .".concat(classes.formGroup)] = {
            width: "100%"
        },
        _b["& .".concat(classes.input)] = {
            height: "22px",
            padding: "5px",
            paddingLeft: "9px",
            boxSizing: "border-box"
        },
        _b["& .".concat(classes.multiSelect)] = {
            alignSelf: "baseline",
            marginBottom: theme.spacing(1),
            marginLeft: "-2px"
        },
        _b);
});

export { classes, StyledFilterCheckbox as default };
//# sourceMappingURL=index.styled.js.map
